import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../core/services/loader/loader.service';

import lottie from 'lottie-web';

@Component({
    selector: 'app-loader',
    imports: [],
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  show = false;
  animation: any;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.loaderState.subscribe((state: boolean) => {
      this.show = state;
      if (this.show) {
        this.initializeLottie();
      } else {
        this.stopLottie();
      }
    });
  }

  initializeLottie(): void {
    const lottieContainer = document.getElementById('lottie');
    if (lottieContainer) {
      this.animation = lottie.loadAnimation({
        container: lottieContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'assets/animations/task-loader-animation.json',
      });
    }
  }

  stopLottie(): void {
    if (this.animation) {
      this.animation.stop();
      this.animation.destroy();
      this.animation = null;
    }
  }
}
